import styled from 'styled-components';
import Tag from '@components/Tag';

const StyledTag = styled(Tag)`
  margin-right: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallExtraBold}
`;

export default StyledTag;
